module.exports = __webpack_public_path__ + "img/explain_ellipse_white.55ca3177.svg";